// Mobile menu toggle
$('.menuBtn span').click(function(){
    $(this).toggleClass('active');
    $('.headerWrapper header nav').toggleClass('active');
    $('.menuOverlay').toggleClass('active');
});

// menu overlay clocl close
$('.menuOverlay').click(function(){
    $(this).removeClass('active');
    $('.headerWrapper header nav').removeClass('active');
    $('.menuBtn span').removeClass('active');
    
});

// popup overlay click close
$('.popup .bg').click(function(e){
    $(this).closest('.popup').removeClass('active') ;
    
});

// Footer year
const currentYear = new Date().getFullYear();
document.getElementById('current-year').textContent = currentYear;

// department popup close
$('.popup.dept-popup .titleWrap .close').click(function(){
    $(this).closest('.popup.dept-popup').removeClass('active');
});

// department popup 
$('.departments .departmentsContent .cellsWrapper .cell').click(function(){
    const currentID = $(this).attr('id');  
    $('.popup').removeClass('active');
    $('#'+currentID+'-popup').toggleClass('active');
});

// testimonials popup close
$('.popup.testimonial-popup .titleWrap .close').click(function(){
    $(this).closest('.popup.testimonial-popup').removeClass('active');
});

// testimonials popup 
$('.testimonials .cell .textWrap p span').click(function(){
    const currentIDTesti = $(this).attr('id');  
 //    console.log(currentID);
    $('.popup').removeClass('active');
     $('#'+currentIDTesti+'-popup').toggleClass('active');
 });
 
 // Scroll to section
 $('nav ul li a').click(function(event) {
    event.preventDefault();  
    const menuID = $(this).attr('href');  
    const targetOffset = $(menuID).offset().top;  

    // Animate scrolling to the target section minus 80 pixels
    $('html, body').animate({
        scrollTop: targetOffset - 50  
    }, 1000);

    $('.menuBtn span').removeClass('active');
    $('.menuOverlay').removeClass('active');
    $('.headerWrapper header nav').removeClass('active');
});
